document.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-user-exit')) {
        window.cleanupWhiteLabel();
    }
});
